import React, { PureComponent } from 'react';

import { Grid } from 'components/grid';
import { Player } from 'modules/player/components';
import PropTypes from 'prop-types';

export default class FilePlayerEmbed extends PureComponent {
  static propTypes = {
    isNewItemsDisabled: PropTypes.bool,
    mediaId: PropTypes.string,
    onInputFiles: PropTypes.func,
    entityType: PropTypes.string,
    loading: PropTypes.bool,
    reusable: PropTypes.bool,
    fileLibraryProvider: PropTypes.number
  };

  static defaultProps = {
    loading: false
  };

  render() {
    const { mediaId, loading } = this.props;

    return (
      <Grid
        block
        noborder
        nomargin
        nopadding
        className="file__content__player "
      >
        <div className="file__player__embed__upload">
          <Player loading={loading} mediaId={mediaId} />
        </div>
      </Grid>
    );
  }
}
